import React from 'react';
import { NavLink } from 'react-router-dom';
import { css, cx } from 'emotion';
import { TEXT_GRAY, DARK_GRAY, GRAY } from 'config/colors';
import { RouteUrls } from 'routes/RouteConstants';
import { connect, RootStateOrAny } from 'react-redux';
import { selectClientConfigurations } from 'state/user/selectors';
import { usePermissions, AppFeaturePermissions } from 'contexts';

const navbar = css`
    width: 100%;
    background-color: ${GRAY};
    min-height: 40px;
    padding-top: 10px;
    border-bottom: 1px solid ${DARK_GRAY};
    overflow: hidden;
`;

const button = css`
    padding: 12px 16px;
    font-size: 14px;
    border: 1px solid ${DARK_GRAY};
    text-decoration: none;
    color: ${TEXT_GRAY};
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: ${TEXT_GRAY};
    }
`;

const activeButton = css`
    color: ${TEXT_GRAY};
    font-weight: bold;
    background-color: #e5e6e7;
`;

interface LeasesNavbarProps {
    className?: string;
    expirationEnabled: boolean;
    rentRollEnabled: boolean;
    tenantsEnabled: boolean;
}

const LeasesNavbar = ({
    className,
    expirationEnabled,
    rentRollEnabled,
    tenantsEnabled,
}: LeasesNavbarProps) => {
    const { featurePermissions } = usePermissions();
    if (!expirationEnabled && !tenantsEnabled && !rentRollEnabled) {
        return null;
    }

    const showRentRoll = featurePermissions.includes(
        AppFeaturePermissions.RentRoll
    );
    const showExpirationSchedule = featurePermissions.includes(
        AppFeaturePermissions.ExpirationSchedule
    );
    const showTenants = featurePermissions.includes(
        AppFeaturePermissions.Tenants
    );
    const showPerformanceOverview = featurePermissions.includes(
        AppFeaturePermissions.PerformanceOverview
    );

    return (
        <div className={cx([navbar, className])}>
            {showPerformanceOverview && (
                <NavLink
                    to={RouteUrls.LEASES_PERFORMANCE_OVERVIEW}
                    className={button}
                    activeClassName={activeButton}
                >
                    Performance Overview
                </NavLink>
            )}
            {rentRollEnabled && showRentRoll && (
                <NavLink
                    to={RouteUrls.LEASE_RENT_ROLL}
                    className={button}
                    activeClassName={activeButton}
                >
                    Rent Roll
                </NavLink>
            )}
            {expirationEnabled && showExpirationSchedule && (
                <NavLink
                    to={RouteUrls.LEASES_EXPIRATIONS_SCHEDULE}
                    className={button}
                    activeClassName={activeButton}
                >
                    Expiration Schedule
                </NavLink>
            )}
            {tenantsEnabled && showTenants && (
                <NavLink
                    to={RouteUrls.LEASES_TENANTS}
                    className={button}
                    activeClassName={activeButton}
                >
                    Tenants
                </NavLink>
            )}
        </div>
    );
};

const mapState = (state: RootStateOrAny) => {
    const clientConfig = selectClientConfigurations(state);
    const {
        FEATURE_EXPIRATION_SCHEDULE: expirationEnabled,
        FEATURE_RENT_ROLL: rentRollEnabled,
        FEATURE_TENANTS: tenantsEnabled,
    } = clientConfig;
    return {
        expirationEnabled,
        rentRollEnabled,
        tenantsEnabled,
    };
};

export default connect(mapState)(LeasesNavbar);
